import styled from 'styled-components';

export const LearnFinancingSubText = styled.div`
  font-size: 14px;
  text-align: center;
  padding: 30px 0px;
  display: inline;
`;

export const Bold = styled.p`
  font-weight: 700;
  display: inline;
`;

export const FinancingQuestionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 5px 0px 5px 0px;
`;
